module.exports = __webpack_public_path__ + "static/img/majorCourse.9eb6118.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/majorCourse.jpg
// module id = 40E6
// module chunks = 1